import { getGtmEventQueue } from './gtmEventQueue';
import { eventTypeConstants } from './constants';

type PerfUserTiming = {
    category?: string;
    var: string;
    value: number;
    label: string;
};

type PerfWebVital = {
    label: string;
    value: number;
    action: string;
};

/**
 * Used for tracking events that measure time. Mostly used for performance tracking.
 */
export function trackUserTiming(trackObj?: PerfUserTiming | null): void {
    if (trackObj && trackObj.var && typeof trackObj.value === 'number') {
        const gtmEventQueue = getGtmEventQueue();
        const gtmData = {
            category: trackObj.category || trackObj.var,
            event: eventTypeConstants.EVENT_PERF_USER_TIMING,
            var: trackObj.var,
            value: trackObj.value,
            label: trackObj.label || 'none',
        };

        gtmEventQueue.push(gtmData);
    }
}

export function trackWebVitalsEvent(trackObj?: PerfWebVital): void {
    if (
        trackObj &&
        trackObj.label &&
        typeof trackObj.value === 'number' &&
        !isNaN(trackObj.value)
    ) {
        const gtmEventQueue = getGtmEventQueue();
        const gtmData = {
            category: 'Web Vitals',
            event: eventTypeConstants.EVENT_PERF_WEB_VITALS,
            action: trackObj.action, // metric name
            value: trackObj.value, // metric measurement
            label: trackObj.label, // unique ID for current page load
        };

        gtmEventQueue.push(gtmData);
    }
}
